const ROTA_POR_TIPO = {
  NOVA_SOLICITACAO: '/ParaAnalise',
  SOLICITACAO_CONCEDIDA: '/ConfirmarConcessao',
  SOLICITACAO_RECUSADA: '/VagasSolicitadas',
  CONCESSAO_CONFIRMADA: '/Confirmadas',
  USUARIO_PENDENTE: '/UsersPendentes',
};

export function rotaNotificacao(tipo) {
  return ROTA_POR_TIPO[tipo] || null;
}
